import React, {useEffect} from "react";
import {useTranslation} from "react-i18next";
import {BackButton} from "components/BackButton";
import {Layout} from "components/Layout";
import "yanaoDiff/pages/SuggestionsPageYanao/modifications.css";
import {SupportButton} from "../components/profile/SupportButton";
import {NewsList} from "../components/news/newsList";
import {markNewsAsSeen} from "../hooks/useQuery/news/useNewsUnreadCount";

export const NewsSuggestionsPage = () => {
    const {t} = useTranslation("news");

    useEffect(() => {
        markNewsAsSeen();
    }, []);

    return (<Layout>
            <div className="page">
                <header className="page__header">
                    <BackButton/>
                    <p className="page__title">{t("news_suggestions_title")}</p>
                </header>

                <div className="school-page__wrapper">
                    <SupportButton/>
                    <NewsList/>
                </div>

            </div>
        </Layout>);
};
